"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelectionProvider = exports.MultiSelectionProvider = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
class MultiSelectionProvider extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.setSelectedKeys = (selectedKeys) => {
            this.setState({ selectedKeys });
        };
        this.updateSelectionForKey = (key) => {
            this.setState(prevState => {
                const newKeys = Object.assign({}, prevState.selectedKeys);
                if (prevState.selectedKeys[key]) {
                    delete newKeys[key];
                }
                else {
                    newKeys[key] = true;
                }
                return { selectedKeys: newKeys };
            });
        };
        this.clearSelection = () => {
            this.setState({ selectedKeys: {} });
        };
        this.state = { selectedKeys: {} };
    }
    componentDidUpdate(prevProps) {
        if (this.props.selectionId !== prevProps.selectionId) {
            this.setState({ selectedKeys: {} });
        }
    }
    render() {
        return this.props.children({
            selectedKeys: this.state.selectedKeys,
            setSelectedKeys: this.setSelectedKeys,
            updateSelectionForKey: this.updateSelectionForKey,
            clearSelection: this.clearSelection,
        });
    }
}
exports.MultiSelectionProvider = MultiSelectionProvider;
class SingleSelectionProvider extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.updateSelectionForKey = (key) => {
            this.setState(prevState => {
                const newKey = prevState.selectedKeys[key] ? {} : { [key]: true };
                return { selectedKeys: newKey };
            });
        };
        this.onDoubleClickForKey = (key) => {
            this.setState({ selectedKeys: { [key]: true } });
        };
        this.clearSelection = () => {
            this.setState({ selectedKeys: {} });
        };
        this.state = { selectedKeys: {} };
    }
    componentDidUpdate(prevProps) {
        if (this.props.selectionId !== prevProps.selectionId) {
            this.setState({ selectedKeys: {} });
        }
    }
    render() {
        return this.props.children({
            selectedKeys: this.state.selectedKeys,
            updateSelectionForKey: this.updateSelectionForKey,
            doubleClickForKey: this.onDoubleClickForKey,
            clearSelection: this.clearSelection,
        });
    }
}
exports.SingleSelectionProvider = SingleSelectionProvider;
//# sourceMappingURL=SelectionProvider.js.map